import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import IntlCurrencyInput from 'react-intl-currency-input';

import * as Yup from 'yup';
import { Form } from '@unform/web';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';
// import QRCodeLib from 'react-qr-code';
import PixQrCodeModal from '~/components/Pix/PixQrCodeModal';
import { finishCartLink } from '~/store/modules/cart/actions';
import InputSelect from '~/components/Inputs/InputSelect';
// import Loading from '~/components/Loading';
import { getRole } from '~/util/getRole';
import api from '~/services/api';
import {
  formatPrice,
  formatPriceToNumber,
  formatWhatsappPhoneNumber,
} from '~/util/format';
import GiftbackCard from '~/components/GiftbackCard';

import CartProducts from './CartProducts';

const Payment = ({ finishCartState, setFinishCartState }) => {
  const formRef = useRef(null);
  const tooltip = useRef(null);

  const dispatch = useDispatch();

  const roles = useSelector(({ user }) => user.profile.roles);
  const cartState = useSelector(({ cart }) => cart.cart);
  const link_cielo = useSelector(({ cart }) => cart.link_cielo);
  const link_pagarme = useSelector(({ cart }) => cart.link_pagarme);
  const link_mercadopago = useSelector(({ cart }) => cart.link_mercadopago);
  const link_rede = useSelector(({ cart }) => cart.link_rede);
  const link_pagseguro = useSelector(({ cart }) => cart.link_pagseguro);
  // const cartQrCode = useSelector(({ cart }) => cart.qrcode);
  const correios_package = useSelector(({ cart }) => cart.correios_package);
  const done = useSelector(({ cart }) => cart.done);

  const subscriberId = localStorage.getItem('@VIDDY:X-Server');
  const subscriberNomura = '6888af2c-b1c1-431d-a7e6-aea35d2f0286';
  const subscriberNomuraShoes = '83afc2b0-8090-436e-ae8c-8a364ee9839e';
  const subscriberViddyComercial = '504c2f33-f3af-411c-b6f4-c9c483f8b745';
  // const subscriberNomura = '04c1ecc3-fe7a-4d26-880f-5cb1689c79fe';
  const viddyTax = 1.99;
  const freightTax = 1.16;

  const getPaymentTypeByCode = () => {
    if (finishCartState?.data?.payment_type === 0) return { type: 'Link' };

    if (finishCartState?.data?.payment_type === 201)
      return { type: 'Card', method: 'Credit' };

    if (finishCartState?.data?.payment_type === 202)
      return { type: 'Card', method: 'Debit' };

    if (finishCartState?.data?.payment_type === 204)
      return { type: 'Card', method: 'Pix' };

    if (finishCartState?.data?.payment_type === 203) return { type: 'Money' };

    if (finishCartState?.data?.payment_type === 401) return { type: 'Pago' };

    if (cartState?.payment_type === 0) return { type: 'Link' };

    if (cartState?.payment_type === 201)
      return { type: 'Card', method: 'Credit' };

    if (cartState?.payment_type === 202)
      return { type: 'Card', method: 'Debit' };

    if (cartState?.payment_type === 204) return { type: 'Card', method: 'Pix' };

    if (cartState?.payment_type === 203) return { type: 'Money' };

    if (cartState?.payment_type === 401) return { type: 'Pago' };

    return { type: '' };
  };

  const formatCorreiosDeadline = prazo => {
    if (!prazo) return '';

    const dias = Number(prazo);

    // Se por algum motivo não for número, devolve do jeito que veio
    if (Number.isNaN(dias)) return prazo;

    if (dias === 1) {
      return '1 dia útil';
    }

    return `${dias} dias úteis`;
  };

  const [changeErrorMessage, setChangeErrorMessage] = useState(null);
  const [changeValue, setChangeValue] = useState(
    cartState?.payment_process?.change || null
  );
  const [paymentType, setPaymentType] = useState(getPaymentTypeByCode().type);
  const [paymentMethod, setPaymentMethod] = useState(
    getPaymentTypeByCode().method
  );
  const [changeInput, setChangeInput] = useState(
    cartState?.payment_process?.change === '0.00'
  );
  // const [changeInputValue, setChangeInputValue] = useState();
  const [useAutomaticFreight, setUseAutomaticFreight] = useState(null);
  const [useFreeFreight, setUseFreeFreight] = useState(false);
  const [freightValueAmount, setFreightValueAmount] = useState(null);
  const [returnFreightValueAmount, setReturnFreightValueAmount] =
    useState(null);
  const [defaultFreight, setDefaultFreight] = useState(null);
  const [
    freightAlreadyPayed,
    // setFreightAlreadyPayed,
  ] = useState(null);
  const [freightWillBePayed, setFreightWillBePayed] = useState(
    defaultFreight > 0
      ? defaultFreight
      : finishCartState?.userFreight || cartState?.freight_user || 0
  );
  const [totalValueError, setTotalValueError] = useState(null);

  const [correiosOptions, setCorreiosOptions] = useState([]);
  const [selectedCorreiosService, setSelectedCorreiosService] = useState(null);

  // Formas de pagamento habilitadas (payment_types). Default tudo habilitado:
  // erro na request mantém o comportamento atual (mesmo fallback do backend).
  const [enabledPaymentTypes, setEnabledPaymentTypes] = useState({
    link: true,
    pos: true,
    money: true,
    paid: true,
  });

  useEffect(() => {
    const loadPaymentTypes = async () => {
      try {
        const {
          data: { payment_types },
        } = await api.get('utils/available-delivery-services');

        setEnabledPaymentTypes({
          link: payment_types?.link !== false,
          pos: payment_types?.pos !== false,
          money: payment_types?.money !== false,
          paid: payment_types?.paid !== false,
        });
      } catch (err) {
        // Fail-open: mantém tudo habilitado
      }
    };

    loadPaymentTypes();
  }, []);

  const handleSelectCorreiosService = async option => {
    setSelectedCorreiosService(option);

    const price = Number(option.price || option.value || 0);

    setFreightValueAmount(price);
    setFreightWillBePayed(price);

    try {
      await api.post(`/correios/carts/${cartState.id}/selection`, {
        service: option.code || option.name, // 'PAC' ou 'SEDEX'
        price,
        deadline: option.deadline_days || option.deadline || null,
        package: correios_package || {
          peso: option.package?.peso ?? 1,
          comprimento: option.package?.comprimento ?? 16,
          largura: option.package?.largura ?? 11,
          altura: option.package?.altura ?? 2,
          diametro: option.package?.diametro ?? 0,
          formato: option.package?.formato ?? 2,
          box_name: option.package?.box_name ?? null,
        },
      });
    } catch (err) {
      console.error('Erro ao salvar seleção de frete dos Correios', err);
      toast.error('Não foi possível salvar a seleção do frete dos Correios.');
    }
  };

  const initializeCheckoutMethods = useCallback(() => {
    return [true, true, !!cartState?.store?.bnpl_payment_gateway];
  }, [cartState?.store?.bnpl_payment_gateway]);

  const [checkoutMethods, setCheckoutMethods] = useState(
    initializeCheckoutMethods
  );
  useEffect(() => {
    setCheckoutMethods(initializeCheckoutMethods());
  }, [initializeCheckoutMethods]);
  const [checkoutMethodsError, setCheckoutMethodsError] = useState('');

  const [showPixQrCodeModal, setShowPixQrCodeModal] = useState(false);
  const [loadingQrCode, setLoadingQrCode] = useState(false);
  const [pixQrCode, setPixQrCode] = useState(false);

  const [maxInstallments, setMaxInstallments] = useState(1);
  const [installmentsOptions, setInstallmentsOptions] = useState([]);
  const [selectedInstallment, setSelectedInstallment] = useState(null);

  const [errorMessage, setErrorMessage] = useState('');
  const [isGiftbackActive, setIsGiftbackActive] = useState(false);

  const [saldoDisponivel, setSaldoDisponivel] = useState(0.0);
  const [saldoTotal, setSaldoTotal] = useState(0.0);
  const [valorMinimoResgate, setValorMinimoResgate] = useState(0.0);
  const [dataExpiracao, setDataExpiracao] = useState('');
  const [isLoadingGiftback, setIsLoadingGiftback] = useState(false);
  const [hasGiftbackError, setHasGiftbackError] = useState(false);
  const [hasFreightError, setHasFreightError] = useState(false);
  const [isFreightLoading, setIsFreightLoading] = useState(false);

  const [products, setProducts] = useState([]);

  const [total, setTotal] = useState(
    finishCartState?.amount || cartState?.amount || 0
  );

  const freeFreightThreshold =
    Number(cartState?.store?.minimum_value_for_free_delivery) || 0;

  const freeFreightAvailable =
    Boolean(cartState?.is_for_delivery) &&
    freeFreightThreshold > 0 &&
    Number(total || 0) >= freeFreightThreshold;

  const freeFreightApplied = freeFreightAvailable && useFreeFreight;

  const chargedFreight = freeFreightApplied
    ? 0
    : Number(freightWillBePayed || 0);

  const freightNormalInputValue =
    subscriberId === subscriberViddyComercial
      ? parseFloat(freightWillBePayed) * 1.16
      : parseFloat(freightWillBePayed);

  const handleNoChangeClick = () => {
    setChangeInput(!changeInput);

    if (!changeInput) {
      setChangeValue(0);
      formRef.current.setFieldError('change', '');
    }
  };

  const calculateProductsTotal = useCallback(() => {
    if (products.length === 0) return 0;

    return products.reduce(
      (acc, product) =>
        acc + Number(product.value) * Number(product.prod_amount),
      0
    );
  }, [products]);

  const updateTotal = useCallback(productsTotal => {
    const newTotal = Number(productsTotal);
    setTotal(newTotal);
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      const productsTotal = calculateProductsTotal();
      updateTotal(productsTotal);
    } else {
      setTotal(0);
    }
  }, [products, calculateProductsTotal, updateTotal]);

  const handleGiftbackSwitchChange = isActive => {
    setIsGiftbackActive(isActive);
  };

  useEffect(() => {
    if (!freeFreightAvailable && useFreeFreight) {
      setUseFreeFreight(false);
    }
  }, [freeFreightAvailable, useFreeFreight]);

  const useUserAddress = useSelector(({ cart }) => cart.useUserAddress);
  const address = useSelector(({ cart }) => cart.address);

  const deliveryFleet = useSelector(({ cart }) => cart.deliveryFleet);
  // const totalAcumulator = useSelector(({ cart }) => cart.totalAcumulator);

  const [handleDisabled, setHandleDisabled] = useState(false);

  const [
    cuponNumber,
    // setCuponNumber,
  ] = useState(cartState?.nfce?.number || null);

  const storeOnlinePaymentLimit = useSelector(({ cart }) => {
    return Number(cart.cart?.store?.online_payments_value_limit);
  });

  const linkPaymentAvailable = useMemo(() => {
    if (
      cartState?.store?.has_cielo_merchant_keys ||
      cartState?.store?.has_pagarme_key ||
      cartState?.store?.has_mercadopago_key ||
      cartState?.store?.has_rede_key ||
      cartState?.store?.has_pagseguro_key ||
      cartState?.store?.has_justa_key
    ) {
      return true;
    }
    return false;
  }, [cartState]);

  const bnplPaymentAvailable = useMemo(() => {
    if (cartState?.store?.has_koin_key) return true;
    return false;
  }, [cartState]);

  const formatCurrency = value => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  useEffect(() => {
    if (correiosOptions.length > 0 && !selectedCorreiosService) {
      const defaultOption = correiosOptions[0];

      setSelectedCorreiosService(defaultOption);
      handleSelectCorreiosService(defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correiosOptions]);

  useEffect(() => {
    let maxInstallments2 = 1;

    const totalWithFreight =
      parseFloat(total || 0) +
      chargedFreight -
      (isGiftbackActive ? saldoDisponivel : 0);

    if (cartState?.store?.installment_limit_amount > 0) {
      if (totalWithFreight > 0) {
        maxInstallments2 = Math.floor(
          totalWithFreight / cartState.store.installment_limit_amount
        );
      } else {
        maxInstallments2 = 1; // Caso o total seja 0 e apenas o frete seja considerado
      }
    } else {
      maxInstallments2 = 12; // Exibir até 12 parcelas se não houver installment_limit_amount
    }

    // Aplica a nova regra de quantidade máxima de parcelas
    const maxStoreInstallments = cartState?.store?.maximum_installments || 12; // Se não tiver definido, assume 12
    setMaxInstallments(Math.min(maxInstallments2, maxStoreInstallments));
  }, [cartState, total, chargedFreight, isGiftbackActive, saldoDisponivel]);

  useEffect(() => {
    const totalWithFreight =
      parseFloat(total || 0) +
      chargedFreight -
      (isGiftbackActive ? saldoDisponivel : 0);

    const options = [];

    if (totalWithFreight > 0) {
      const maxInstallmentsToUse = maxInstallments > 0 ? maxInstallments : 1;

      // Aplicar a regra do máximo de parcelas definido pela loja
      const maxStoreInstallments = cartState?.store?.maximum_installments || 12;
      const finalMaxInstallments = Math.min(
        maxInstallmentsToUse,
        maxStoreInstallments
      );

      for (let i = 1; i <= finalMaxInstallments; i += 1) {
        const installmentValue = (totalWithFreight / i).toFixed(2);
        options.push({
          value: i,
          label: `${i}x de ${formatCurrency(installmentValue)}`,
        });
      }
    } else {
      const inputValue =
        parseFloat(total || 0) +
        chargedFreight -
        (isGiftbackActive ? saldoDisponivel : 0);

      options.push({
        value: 1,
        label: `1x de ${formatCurrency(inputValue.toFixed(2))}`,
      });
    }

    setInstallmentsOptions(options);
    setSelectedInstallment(options[0]); // Selecionar automaticamente a primeira parcela
  }, [
    maxInstallments,
    total,
    chargedFreight,
    isGiftbackActive,
    saldoDisponivel,
    cartState,
  ]);

  useEffect(() => {
    // Caso especial: só frete (total = 0) e temos valor de frete
    if (freightWillBePayed <= 0 || total !== 0) return;

    const totalWithFreight =
      parseFloat(freightWillBePayed || 0) -
      (isGiftbackActive ? saldoDisponivel : 0);

    if (totalWithFreight <= 0) return;

    const minInstallmentAmount =
      Number(cartState?.store?.installment_limit_amount) || 0;
    const maxStoreInstallments =
      Number(cartState?.store?.maximum_installments) || 12;

    let maxInstallmentsToUse = 1;

    if (minInstallmentAmount > 0) {
      maxInstallmentsToUse = Math.floor(
        totalWithFreight / minInstallmentAmount
      );
    }

    if (!Number.isFinite(maxInstallmentsToUse) || maxInstallmentsToUse < 1) {
      maxInstallmentsToUse = 1;
    }

    const finalMaxInstallments = Math.min(
      maxInstallmentsToUse,
      maxStoreInstallments
    );

    setMaxInstallments(finalMaxInstallments);

    const options = [];
    for (let i = 1; i <= finalMaxInstallments; i += 1) {
      const installmentValue = (totalWithFreight / i).toFixed(2);
      options.push({
        value: i,
        label: `${i}x de ${formatCurrency(installmentValue)}`,
      });
    }

    setInstallmentsOptions(options);
    setSelectedInstallment(options[0]);
  }, [
    freightWillBePayed,
    total,
    isGiftbackActive,
    saldoDisponivel,
    cartState?.store?.installment_limit_amount,
    cartState?.store?.maximum_installments,
  ]);

  /*
  useEffect(() => {
    // Atualizar parcelas quando o valor do frete estiver disponível desde o início
    if (freightWillBePayed > 0 && total === 0) {
      const maxStoreInstallments = cartState?.store?.maximum_installments || 12;

      const totalWithFreight =
        parseFloat(total) +
        parseFloat(freightWillBePayed) -
        (isGiftbackActive ? saldoDisponivel : 0);

      // Ajusta a quantidade de parcelas com base na nova regra
      let maxInstallmentsToUse = 1;
      if (totalWithFreight > 0) {
        maxInstallmentsToUse = Math.floor(
          totalWithFreight / cartState.store.installment_limit_amount
        );
      }

      // Respeitar a quantidade máxima de parcelas configurada pela loja
      const finalMaxInstallments = Math.min(
        maxInstallmentsToUse,
        maxStoreInstallments
      );

      setMaxInstallments(finalMaxInstallments);

      setInstallmentsOptions([
        {
          value: finalMaxInstallments,
          label: `${finalMaxInstallments}x de ${formatCurrency(
            (totalWithFreight / finalMaxInstallments).toFixed(2)
          )}`,
        },
      ]);

      setSelectedInstallment({
        value: finalMaxInstallments,
        label: `${finalMaxInstallments}x de ${formatCurrency(
          (totalWithFreight / finalMaxInstallments).toFixed(2)
        )}`,
      });
    }
  }, [freightWillBePayed, total, isGiftbackActive, saldoDisponivel, cartState]);
  */

  /*
  const getGiftbackData = useCallback(async (totalValue) => {
    if (!cartState.id) return;

    setIsLoadingGiftback(true);

    try {
      const { data: { giftback } } = await api.get(`${getRole(roles)}/carts/${cartState.id}/giftback/${totalValue}`);
      setSaldoDisponivel(parseFloat(giftback.amount));
      setValorMinimoResgate(parseFloat(giftback.min_purchase));
      setDataExpiracao(giftback.expiration_date);
    } catch (error) {
      console.error("Erro ao buscar dados do Giftback:", error);
    } finally {
      setIsLoadingGiftback(false);
    }
  }, [cartState.id, roles]);
  */

  useEffect(() => {
    if (!cartState.id) return undefined;
    if (!cartState?.store?.has_crmbonus_key) return undefined;
    if (!(Number(total) > 0) || hasGiftbackError) return undefined;

    const timer = setTimeout(async () => {
      setIsLoadingGiftback(true);

      try {
        const {
          data: { giftback },
        } = await api.get(
          `${getRole(roles)}/carts/${cartState.id}/giftback/${total}`
        );
        setSaldoDisponivel(parseFloat(giftback.amount));
        setSaldoTotal(parseFloat(giftback.total_amount));
        setValorMinimoResgate(parseFloat(giftback.min_purchase));
        setDataExpiracao(giftback.expiration_date);
      } catch (error) {
        console.error('Erro ao buscar dados do Giftback:', error);
        setHasGiftbackError(true);
      } finally {
        setIsLoadingGiftback(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    total,
    cartState.id,
    cartState?.store?.has_crmbonus_key,
    roles,
    hasGiftbackError,
  ]);

  useEffect(() => {
    // setFreightValueAmount(null);
    setReturnFreightValueAmount(null);
    setDefaultFreight(null);

    if (
      cartState?.is_for_delivery &&
      (subscriberId === subscriberNomura ||
        subscriberId === subscriberNomuraShoes) &&
      cartState?.delivery_method !== 'CORREIOS_EXPRESS' &&
      cartState?.delivery_method !== 'CORREIOS'
    ) {
      setDefaultFreight(cartState?.store?.default_freight || 0);
      setFreightWillBePayed(cartState?.store?.default_freight || 0);
    }

    if (cartState?.store?.use_automatic_freight) {
      setUseAutomaticFreight(true);
      setFreightWillBePayed(freightValueAmount);
    }

    /*
    if (
      cartState?.is_for_delivery &&
      cartState?.store?.default_freight !== undefined &&
      cartState?.store?.default_freight > 0 &&
      subscriberId === subscriberNomura &&
      cartState?.delivery_method !== 'CORREIOS'
    ) {
      setDefaultFreight(cartState?.store?.default_freight || 0);
      setFreightWillBePayed(cartState?.store?.default_freight || 0);
    }
    */

    if (
      (subscriberId === subscriberNomura ||
        subscriberId === subscriberNomuraShoes) &&
      (cartState?.delivery_method === 'CORREIOS_EXPRESS' ||
        cartState?.delivery_method === 'CORREIOS')
    ) {
      setFreightWillBePayed(parseFloat(30));
    }
  }, [
    total,
    cartState,
    roles,
    address,
    paymentType,
    hasGiftbackError,
    hasFreightError,
    freightValueAmount,
    isFreightLoading,
    subscriberId,
  ]);

  useEffect(() => {
    if (!cartState.id || !paymentType) return;

    const paymentTable = {
      Link: 0,
      Card: 201,
      Money: 203,
      Pago: 401,
    };

    const getPaymentCodeByType = () => paymentTable[paymentType] || 0;

    const getFreight = async () => {
      setIsFreightLoading(true);

      try {
        if (cartState?.delivery_method === 'CORREIOS') {
          const packagePayload = {
            peso: correios_package?.weight ?? null,
            comprimento: correios_package?.length ?? null,
            largura: correios_package?.width ?? null,
            altura: correios_package?.height ?? null,
            diametro: 0,
            formato: 2,
            box_name: correios_package?.box_name ?? null,
          };

          const { data } = await api.post(`/correios/frete/${cartState.id}`, {
            package: packagePayload,
          });

          // data = { PAC: { valor, prazoDias }, SEDEX: { valor, prazoDias } }
          const options = [];

          if (data.PAC) {
            options.push({
              code: 'PAC',
              name: 'PAC',
              price: Number(data.PAC.valor || 0),
              deadline: formatCorreiosDeadline(data.PAC.prazoDias),
            });
          }

          if (data.SEDEX) {
            options.push({
              code: 'SEDEX',
              name: 'SEDEX',
              price: Number(data.SEDEX.valor || 0),
              deadline: formatCorreiosDeadline(data.SEDEX.prazoDias),
            });
          }

          setCorreiosOptions(options);

          if (options.length > 0) {
            const initial = options[0];
            setSelectedCorreiosService(initial);
            setFreightValueAmount(initial.price);
            setFreightWillBePayed(initial.price);
          } else {
            setFreightValueAmount(0);
            setFreightWillBePayed(0);
          }

          setReturnFreightValueAmount(0);
          setHasFreightError(false);
          return;
        }

        const {
          data: { freight, return_freight },
        } = await api.get(
          `${getRole(roles)}/carts/${
            cartState.id
          }/delivery/freight/${getPaymentCodeByType()}`
        );

        setFreightValueAmount(freight || 0);
        setReturnFreightValueAmount(return_freight || 0);
        setHasFreightError(false);
      } catch (error) {
        console.error('Erro ao buscar dados do frete:', error);
        setFreightValueAmount(0);
        setReturnFreightValueAmount(0);
        setHasFreightError(true);
        setCorreiosOptions([]);
        setSelectedCorreiosService(null);

        const message = error?.response?.data?.message;
        if (message) {
          toast.error(message, {
            autoClose: error?.response?.data?.duration || 8000,
          });
        }
      } finally {
        setIsFreightLoading(false);
      }
    };

    getFreight();
  }, [
    paymentType,
    cartState.id,
    roles,
    cartState?.delivery_method,
    correios_package,
  ]);

  useEffect(() => {
    const isNomura =
      subscriberId === subscriberNomura ||
      subscriberId === subscriberNomuraShoes;

    const isCorreios = ['CORREIOS_EXPRESS', 'CORREIOS'].includes(
      cartState?.delivery_method
    );

    if (
      cartState?.is_for_delivery &&
      cartState?.store?.default_freight !== undefined &&
      cartState?.store?.default_freight > 0 &&
      !(isNomura && isCorreios)
    ) {
      setDefaultFreight(cartState.store.default_freight);
      setFreightWillBePayed(cartState?.store?.default_freight);
    } else {
      setFreightWillBePayed(
        finishCartState?.userFreight || cartState?.freight_user || 0
      );
    }
  }, [cartState, defaultFreight, finishCartState, subscriberId]);

  useEffect(() => {
    if (
      cartState.is_for_delivery &&
      subscriberId === subscriberViddyComercial
    ) {
      setFreightWillBePayed(freightValueAmount * freightTax);
    }
  }, [cartState, freightValueAmount, subscriberId, subscriberViddyComercial]);

  const PAYMENTS_TYPES = useMemo(
    () => [
      {
        id: 1,
        available:
          (linkPaymentAvailable || bnplPaymentAvailable) &&
          enabledPaymentTypes.link,
        label: `${cartState?.store?.payment_gateway ? 'Cartão / Pix' : ''}${
          cartState?.store?.bnpl_payment_gateway ? ' / Pix Parcelado' : ''
        }`,
        tag: 'Link',
        icon: 'fas fa-link',
        value: false,
        col_padding: 'px-0',
        checked: paymentType === 'Link',
        col_width: 3,
      },
      // {
      //   id: 2,
      //   available: pixPaymentAvailable,
      //   label: 'Pix',
      //   tag: 'Pix',
      //   icon: 'las la-university',
      //   value: false,
      //   col_padding: 'px-0 pr-lg-2',
      //   checked: paymentType === 'Pix',
      //   col_width: 3,
      // },
      {
        id: 2,
        available:
          deliveryFleet !== 'RETIRAR' &&
          deliveryFleet !== 'UBER' &&
          deliveryFleet !== 'ENTREGA99' &&
          deliveryFleet !== 'IFOOD_ENVIOS' &&
          deliveryFleet !== 'VIDDY_DELIVERIES' &&
          cartState.delivery_method !== 'CORREIOS' &&
          cartState.delivery_method !== 'CORREIOS_EXPRESS' &&
          enabledPaymentTypes.pos,
        label: 'Maquineta / POS',
        tag: 'Card',
        icon: 'las la-credit-card',
        value: false,
        col_padding: 'px-0 pl-lg-2',
        checked: paymentType === 'Card',
        col_width: 3,
      },
      {
        id: 3,
        available:
          deliveryFleet !== 'RETIRAR' &&
          deliveryFleet !== 'UBER' &&
          deliveryFleet !== 'ENTREGA99' &&
          deliveryFleet !== 'IFOOD_ENVIOS' &&
          deliveryFleet !== 'VIDDY_DELIVERIES' &&
          cartState.delivery_method !== 'CORREIOS' &&
          cartState.delivery_method !== 'CORREIOS_EXPRESS' &&
          enabledPaymentTypes.money,
        label: 'Dinheiro',
        tag: 'Money',
        icon: 'las la-money-bill',
        value: false,
        col_padding: 'px-0 pl-lg-2',
        checked: paymentType === 'Money',
        col_width: 3,
      },
      {
        id: 6,
        available: deliveryFleet !== 'RETIRAR' && enabledPaymentTypes.paid,
        label: 'Pedido Pago - Só Entrega',
        tag: 'Pago',
        icon: 'las la-money-check-alt',
        value: false,
        col_padding: 'px-0 pl-lg-2',
        checked: paymentType === 'Pago',
        col_width: 3,
      },
    ],
    [
      linkPaymentAvailable,
      bnplPaymentAvailable,
      paymentType,
      // pixPaymentAvailable,
      deliveryFleet,
      cartState?.store,
      cartState.delivery_method,
      enabledPaymentTypes,
    ]
  );

  // Disponibilidade por regra de negócio (frota/loja/Correios), SEM o filtro
  // da config payment_types. Usado só para decidir a mensagem de "loja sem
  // método configurado" — que não deve aparecer quando o admin apenas
  // desabilitou formas na configuração.
  const hasBusinessPaymentOption = useMemo(
    () =>
      PAYMENTS_TYPES.some(type => {
        if (type.tag === 'Link') {
          return linkPaymentAvailable || bnplPaymentAvailable;
        }

        if (type.tag === 'Card' || type.tag === 'Money') {
          return (
            deliveryFleet !== 'RETIRAR' &&
            deliveryFleet !== 'UBER' &&
            deliveryFleet !== 'ENTREGA99' &&
            deliveryFleet !== 'IFOOD_ENVIOS' &&
            deliveryFleet !== 'VIDDY_DELIVERIES' &&
            cartState.delivery_method !== 'CORREIOS' &&
            cartState.delivery_method !== 'CORREIOS_EXPRESS'
          );
        }

        if (type.tag === 'Pago') {
          return deliveryFleet !== 'RETIRAR';
        }

        return false;
      }),
    [
      PAYMENTS_TYPES,
      linkPaymentAvailable,
      bnplPaymentAvailable,
      deliveryFleet,
      cartState.delivery_method,
    ]
  );

  const handleFinishOrder = () => {
    if (
      (paymentMethod && paymentType !== 'Link') ||
      paymentType === 'Money' ||
      paymentType === 'Pago' ||
      paymentType === 'Link'
    ) {
      formRef.current.submitForm();
    }
  };

  const handleSubmit = useCallback(
    async data => {
      setHandleDisabled(true);
      const { installments } = data;
      let NumberInstallments;
      let finalAmount = total;

      if (subscriberId === subscriberViddyComercial) {
        finalAmount += viddyTax;
      }

      if (
        subscriberId === subscriberViddyComercial &&
        (freightValueAmount === 0 || freightValueAmount == null)
      ) {
        toast.error('Valor de frete não identificado!');
        setHandleDisabled(false);
        return;
      }

      if (paymentType !== 'Pago' && !total && !freightWillBePayed) {
        setTotalValueError('Esse valor é inválido');
        setHandleDisabled(false);
        return;
      }

      if (cartState.is_for_delivery && !useUserAddress && !address) {
        toast.error('Confirme o endereço');
        setHandleDisabled(false);
        return;
      }

      if (paymentType === 'Money' && !changeInput) {
        try {
          formRef.current.setErrors({});

          if (changeInput) {
            setChangeValue(0);
          } else if (changeValue <= 0) {
            formRef.current.setFieldError(
              'change',
              'Valor de troco deve ser maior que zero.'
            );
            setHandleDisabled(false);
            return;
          }

          const schema = Yup.object().shape({
            change: Yup.number()
              .min(
                total,
                'Para que haja troco, o valor inserido deve ser maior do que o valor da compra.'
              )
              .required('O valor do troco é obrigatório.'),
          });

          await schema.validate(
            { change: changeValue },
            {
              abortEarly: false,
            }
          );
        } catch (err) {
          console.error(err);
          const validationErrors = {};

          if (err instanceof Yup.ValidationError) {
            err.inner.forEach(e => {
              validationErrors[e.path] = e.message;
            });
            formRef.current.setErrors(validationErrors);
          }
          if (err.response && err?.response?.data?.message) {
            toast.error(err?.response?.data?.message, {
              autoClose: err?.response?.data?.duration || 5000,
            });
          }
          setHandleDisabled(false);
          return;
        }
      }

      if (installments === '') {
        NumberInstallments = 1;
      } else {
        NumberInstallments = Number(installments);
      }

      if (NumberInstallments < 1 || NumberInstallments > 12) {
        toast.error('Número de parcelas inválido!');
        setHandleDisabled(false);
        return;
      }

      if (
        (cartState.is_cross || cartState?.delivery_method === 'CORREIOS') &&
        products.length < 1
      ) {
        toast.error('É necessário adicionar produtos para avançar!');
        setHandleDisabled(false);
        return;
      }

      const giftbackData = isGiftbackActive
        ? {
            useGiftback: true,
            giftback_amount: saldoDisponivel,
          }
        : {};

      if (paymentType === 'Card') {
        let paymentData;

        if (paymentMethod === 'Credit') {
          paymentData = {
            payment_type: 201,
            installments: selectedInstallment.value || 1,
          };
        } else if (paymentMethod === 'Debit') {
          paymentData = { payment_type: 202 };
        } else if (paymentMethod === 'Pix') {
          paymentData = { payment_type: 204 };
        }

        setFinishCartState(prevState => ({
          ...prevState,
          data: paymentData,
          cart_id: cartState.id,
          products,
          amount: finalAmount,
          nfce: cuponNumber,
          userFreight: deliveryFleet !== 'RETIRAR' ? chargedFreight : 0,
          freight: freightValueAmount,
          return_freight: returnFreightValueAmount,
          default_freight: defaultFreight,
          ...giftbackData,
        }));
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.has_pix_key &&
        cartState.store?.payment_gateway === 'cielo'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 105,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.has_pix_key &&
        cartState.store?.payment_gateway === 'rede'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 105,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.payment_gateway === 'pagseguro'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 114,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (paymentType === 'Pago') {
        setFinishCartState(prevState => ({
          ...prevState,
          data: {
            payment_type: 401,
          },
          cart_id: cartState.id,
          products,
          amount: finalAmount || 0,
          nfce: cuponNumber,
          userFreight: deliveryFleet !== 'RETIRAR' ? chargedFreight : 0,
          freight: freightValueAmount,
          return_freight: returnFreightValueAmount,
          default_freight: defaultFreight,
          freightAlreadyPayed,
          ...giftbackData,
        }));
      }
      if (
        paymentType === 'Pix' &&
        ['pagarme', 'pagarme_hub'].includes(cartState.store?.payment_gateway)
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 106,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.payment_gateway === 'mercadopago'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 110,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.payment_gateway === 'cielo'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 112,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (
        paymentType === 'Pix' &&
        cartState.store?.payment_gateway === 'justa'
      ) {
        dispatch(
          finishCartLink(prevState => ({
            ...prevState,
            payment_type: 118,
            cart_id: cartState.id,
            products,
            amount: finalAmount,
            nfce: cuponNumber,
            page_state: {
              setLoadingQrCode,
              setPixQrCode,
              setShowPixQrCodeModal,
              setHandleDisabled,
            },
            ...giftbackData,
          }))
        );
      }
      if (paymentType === 'Money') {
        setFinishCartState(prevState => ({
          ...prevState,
          data: {
            payment_type: 203,
            change: changeInput ? 0 : changeValue,
          },
          amount: finalAmount,
          nfce: cuponNumber,
          cart_id: cartState.id,
          products,
          freight: freightValueAmount,
          return_freight: returnFreightValueAmount,
          default_freight: defaultFreight,
          userFreight: deliveryFleet !== 'RETIRAR' ? chargedFreight : 0,
          ...giftbackData,
        }));
      }
      if (paymentType === 'Link') {
        let display_payment = '';

        if (!checkoutMethods[0]) display_payment += 'hide-card';
        if (!checkoutMethods[1]) display_payment += 'hide-pix';
        if (!checkoutMethods[2]) display_payment += 'hide-bnpl';
        if (storeOnlinePaymentLimit !== 0 && total > storeOnlinePaymentLimit)
          display_payment += 'hide-card';

        setFinishCartState(prevState => ({
          ...prevState,
          payment_type: 0,
          amount: finalAmount,
          nfce: cuponNumber,
          display_payment,
          max_installments: selectedInstallment.value || 1,
          cart_id: cartState.id,
          products,
          freight: freightValueAmount,
          return_freight: returnFreightValueAmount,
          default_freight: defaultFreight,
          userFreight: deliveryFleet !== 'RETIRAR' ? chargedFreight : 0,
          ...giftbackData,
        }));
      }
    },
    [
      address,
      cartState?.id,
      cartState?.is_for_delivery,
      cartState?.store?.payment_gateway,
      cartState?.store?.has_pix_key,
      cartState?.is_cross,
      cartState?.delivery_method,
      dispatch,
      checkoutMethods,
      paymentMethod,
      paymentType,
      useUserAddress,
      total,
      changeInput,
      cuponNumber,
      setFinishCartState,
      freightWillBePayed,
      chargedFreight,
      freightAlreadyPayed,
      freightValueAmount,
      returnFreightValueAmount,
      defaultFreight,
      storeOnlinePaymentLimit,
      changeValue,
      deliveryFleet,
      selectedInstallment,
      isGiftbackActive,
      saldoDisponivel,
      subscriberId,
      subscriberViddyComercial,
      products,
    ]
  );

  const isBtnDisabled = useMemo(() => {
    if (
      (cartState.is_cross || cartState?.delivery_method === 'CORREIOS') &&
      (!products || products.length === 0)
    )
      return true;

    if (Number(total || 0) === 0 && chargedFreight === 0) return false;

    if (
      paymentType === 'Money' &&
      !changeInput &&
      Number(changeValue) <= Number(total) + chargedFreight
    )
      return true;

    if (!paymentType || handleDisabled) return true;

    if (paymentType === 'Card' && !paymentMethod) return true;

    if (!done && !useUserAddress && !address) return true;

    if (
      paymentType === 'Pago' &&
      (!total || (freightAlreadyPayed === false && !chargedFreight))
    )
      return false;

    if (paymentType === 'Link' && !total && !chargedFreight) return true;

    return false;
  }, [
    paymentType,
    done,
    useUserAddress,
    address,
    total,
    freightAlreadyPayed,
    changeInput,
    changeValue,
    chargedFreight,
    handleDisabled,
    paymentMethod,
    cartState.is_cross,
    cartState.delivery_method,
    products,
  ]);

  // Função para verificar se pelo menos um método está selecionado
  const atLeastOneMethodSelected = methods => methods.some(method => method);

  // Função para atualizar métodos de checkout
  const updateCheckoutMethods = index => {
    const updatedMethods = [...checkoutMethods];
    updatedMethods[index] = !updatedMethods[index];

    if (atLeastOneMethodSelected(updatedMethods)) {
      setCheckoutMethods(updatedMethods);
      setCheckoutMethodsError(null);
    } else {
      setCheckoutMethodsError('Ao menos um método deve estar selecionado.');
    }
  };

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        ref={formRef}
        initialData={{
          link_cielo,
          link_pagarme,
          link_mercadopago,
          link_rede,
          link_pagseguro,
        }}
        noValidate
      >
        <Card className="card new-layout mb-0">
          <CardBody className="card-body new-layout px-5">
            <Row className="w-100 mx-0 font-size-20 font-weight-700 text-gray-700 mb-4">
              <h2 className="font-size-20">Opções de Pagamento</h2>
            </Row>

            <Row className="w-100 mx-0 mb-0">
              {/* <PaymentsAvailabilityAlerts /> */}
              <Nav className="w-100" pills>
                <Row className="w-100 mx-0">
                  {!hasBusinessPaymentOption && (
                    <Alert color="info">
                      Loja selecionada não possui método de pagamento
                      configurado, vendas com retirada em loja só funciona no
                      formato online, consulte um administrador para fazer essa
                      configuração.
                    </Alert>
                  )}

                  {hasBusinessPaymentOption &&
                    PAYMENTS_TYPES.filter(type => type.available).length <=
                      0 && (
                      <Alert color="info">
                        Nenhuma forma de pagamento está habilitada para esta
                        venda. Verifique as configurações de formas de pagamento
                        com um administrador.
                      </Alert>
                    )}
                  {PAYMENTS_TYPES.filter(type => type.available).map(type => (
                    <React.Fragment key={type.id}>
                      <Col lg={type.col_width} className={type.col_padding}>
                        <NavItem>
                          <NavLink
                            ref={type.id === 1 ? tooltip : null}
                            className={`new-layout-nav-pill card d-flex flex-column align-items-center h-fit-content w-100 ${
                              type.checked ? 'checked' : 'unchecked'
                            } font-size-14`}
                            onClick={() => setPaymentType(type.tag)}
                            to="#"
                            // disabled={type.opacity}
                          >
                            {/* <i className={`${type.icon} fs-30 mb-2`} /> */}
                            <span className="text-nowrap">{type.label}</span>
                          </NavLink>
                        </NavItem>
                      </Col>
                    </React.Fragment>
                  ))}
                </Row>
              </Nav>
            </Row>
          </CardBody>
        </Card>
        {paymentType && (
          <>
            {(cartState.is_cross ||
              cartState?.delivery_method === 'CORREIOS') && (
              <Row className="w-100 mx-0 my-2">
                <Col lg={12} className="px-0 py-2">
                  <CartProducts
                    setProductsTotal={updateTotal}
                    setProducts={setProducts}
                  />
                </Col>
              </Row>
            )}
            <Row className="w-100 mx-0 my-2">
              {subscriberId !== subscriberViddyComercial && (
                <Col lg={6} className="px-0 py-2 pr-lg-2">
                  <Card className="card new-layout h-100">
                    <CardBody className="card-body new-layout pb-0 pt-4 px-5">
                      <h2 className="font-size-20">
                        {
                          PAYMENTS_TYPES.find(({ tag }) => tag === paymentType)
                            ?.label
                        }
                      </h2>
                      <Row className="w-100 mx-0 w-100 mx-0 d-flex flex-row align-items-center">
                        {!cartState.is_cross &&
                          cartState.delivery_method !== 'CORREIOS' && (
                            <Col xs={12} sm={12} className="px-0">
                              <FormGroup className="w-100 d-flex mb-1 flex-column">
                                <Label>Valor total da compra</Label>
                                <IntlCurrencyInput
                                  inputmode="decimal"
                                  currency="BRL"
                                  name="finalValue"
                                  id="finalValue"
                                  onChange={(_, floatValue) => {
                                    setTotal(floatValue);
                                    if (floatValue === 0) {
                                      setErrorMessage(
                                        'Para acrescentar o valor do giftback, insira um valor de compra.'
                                      );
                                    } else {
                                      setErrorMessage('');
                                    }

                                    const totalWithFreight =
                                      floatValue +
                                      parseFloat(freightWillBePayed) -
                                      (isGiftbackActive ? saldoDisponivel : 0);

                                    const minInstallmentAmount =
                                      cartState?.store
                                        ?.installment_limit_amount || 0;
                                    const maxStoreInstallments =
                                      cartState?.store?.maximum_installments ||
                                      12; // Novo limite

                                    let maxInstallmentsToUse = 1;

                                    if (
                                      minInstallmentAmount > 0 &&
                                      totalWithFreight > 0
                                    ) {
                                      maxInstallmentsToUse = Math.floor(
                                        totalWithFreight / minInstallmentAmount
                                      );
                                    }

                                    // Agora limitamos o número máximo de parcelas para respeitar o máximo configurado na loja
                                    const finalMaxInstallments = Math.min(
                                      maxInstallmentsToUse,
                                      maxStoreInstallments,
                                      12
                                    ); // Garantindo que nunca ultrapasse 12 parcelas

                                    setMaxInstallments(finalMaxInstallments);
                                  }}
                                  placeholder="Valor Unitário"
                                  className={`dc-discount-input input-color form-control ${
                                    totalValueError ? 'border-danger' : ''
                                  }`}
                                  value={Number(total)}
                                  onFocus={() => setTotalValueError(null)}
                                  config={{
                                    locale: 'pt-BR',
                                    formats: {
                                      number: {
                                        BRL: {
                                          style: 'currency',
                                          currency: 'BRL',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        },
                                      },
                                    },
                                  }}
                                  onBlur={e => {
                                    if (!changeInput) {
                                      setChangeErrorMessage(null);
                                      formRef.current.setFieldError(
                                        'change',
                                        ''
                                      );
                                      return;
                                    }

                                    if (
                                      formatPriceToNumber(e.target.value) +
                                        freightWillBePayed <=
                                      changeValue
                                    ) {
                                      setChangeErrorMessage(null);
                                      return;
                                    }
                                    setChangeErrorMessage(
                                      'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                    );
                                    formRef.current.setFieldError(
                                      'change',
                                      'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                    );
                                  }}
                                />
                                {totalValueError ? (
                                  <span className="text-danger">
                                    {totalValueError}
                                  </span>
                                ) : null}
                                {paymentType === 'Link' &&
                                  storeOnlinePaymentLimit !== 0 &&
                                  parseFloat(total) +
                                    parseFloat(freightWillBePayed) >
                                    storeOnlinePaymentLimit && (
                                    <Alert color="info" className="mt-4 mb-0">
                                      O valor desta venda ultrapassa o limite
                                      para pagamento on-line, desse modo, apenas
                                      a venda através do PIX será liberada para
                                      o cliente, entre em contato com o gerente
                                      para aumentar este limite.
                                    </Alert>
                                  )}
                              </FormGroup>
                            </Col>
                          )}

                        {paymentType === 'Link' &&
                          cartState.is_cross &&
                          storeOnlinePaymentLimit !== 0 &&
                          parseFloat(total) + parseFloat(freightWillBePayed) >
                            storeOnlinePaymentLimit && (
                            <Alert color="info" className="mt-4 mb-0">
                              O valor desta venda ultrapassa o limite para
                              pagamento on-line, desse modo, apenas a venda
                              através do PIX será liberada para o cliente, entre
                              em contato com o gerente para aumentar este
                              limite.
                            </Alert>
                          )}

                        {paymentType === 'Card' && (
                          <Col className="px-0 mt-3">
                            <Label>Forma de Pagamento</Label>

                            <Row>
                              <Col xs={4}>
                                <CustomInput
                                  type="radio"
                                  id="checkout-methods-1"
                                  name="paymentModality"
                                  className="text-primary z-index-0"
                                  label="Crédito"
                                  checked={paymentMethod === 'Credit'}
                                  onChange={() => setPaymentMethod('Credit')}
                                />
                              </Col>
                              <Col>
                                <CustomInput
                                  type="radio"
                                  id="checkout-methods-2"
                                  name="paymentModality"
                                  className="text-primary z-index-0"
                                  label="Débito"
                                  checked={paymentMethod === 'Debit'}
                                  onChange={() => setPaymentMethod('Debit')}
                                />
                              </Col>
                              <Col>
                                <CustomInput
                                  type="radio"
                                  id="checkout-methods-3"
                                  name="paymentModality"
                                  className="text-primary z-index-0"
                                  label="Pix"
                                  checked={paymentMethod === 'Pix'}
                                  onChange={() => setPaymentMethod('Pix')}
                                />
                              </Col>
                            </Row>
                          </Col>
                        )}

                        {(paymentType === 'Link' ||
                          (paymentType === 'Card' &&
                            paymentMethod === 'Credit')) && (
                          <Col xs={12} sm={12} className="px-0 mb-1 mt-2">
                            {!(
                              paymentType === 'Link' &&
                              storeOnlinePaymentLimit !== 0 &&
                              parseFloat(total) +
                                parseFloat(freightWillBePayed) >
                                storeOnlinePaymentLimit
                            ) &&
                              (checkoutMethods[0] || checkoutMethods[2]) && (
                                <>
                                  <Label>Quantidade de Parcelas</Label>
                                  <i
                                    id="max-installments-tooltip"
                                    className="las la-info-circle font-size-18 font-size-16 text-secondary mb-2 ml-1 h-fit-content"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="max-installments-tooltip"
                                  >
                                    Esse é o número máximo de parcelas em que o
                                    pagamento via Link de Pagamento poderá ser
                                    efetuado.
                                  </UncontrolledTooltip>
                                  <InputSelect
                                    name="installments"
                                    className="common-select"
                                    options={installmentsOptions}
                                    value={selectedInstallment}
                                    onChange={selectedOption => {
                                      setSelectedInstallment(selectedOption);
                                    }}
                                    placeholder="Quantidade de parcelas"
                                    singlePath
                                  />
                                </>
                              )}
                          </Col>
                        )}

                        {(cartState?.store?.payment_gateway ||
                          cartState?.store?.bnpl_payment_gateway) &&
                          !(
                            storeOnlinePaymentLimit !== 0 &&
                            total > storeOnlinePaymentLimit
                          ) &&
                          paymentType === 'Link' && (
                            <>
                              <Col xs={12} className="px-0 mb-0 mt-3">
                                <Label>Link de Pagamento</Label>
                              </Col>

                              <Row
                                className="mx-0 px-1 mb-1 d-flex"
                                style={{ gap: '1.5rem' }}
                              >
                                {cartState?.store?.payment_gateway && (
                                  <CustomInput
                                    type="checkbox"
                                    id="credit-checkout-method"
                                    name="creditCheckoutMethod"
                                    className="text-primary z-index-0"
                                    label="Crédito"
                                    checked={checkoutMethods[0]}
                                    onChange={() => updateCheckoutMethods(0)}
                                  />
                                )}
                                {cartState?.store?.payment_gateway && (
                                  <CustomInput
                                    type="checkbox"
                                    id="pix-checkout-method"
                                    name="pixCheckoutMethod"
                                    className="text-primary z-index-0"
                                    label="Pix"
                                    checked={checkoutMethods[1]}
                                    onChange={() => updateCheckoutMethods(1)}
                                  />
                                )}
                                {cartState?.store?.bnpl_payment_gateway && (
                                  <CustomInput
                                    type="checkbox"
                                    id="bnpl-checkout-method"
                                    name="bnplCheckoutMethod"
                                    className="text-primary z-index-0"
                                    label="Pix Parcelado"
                                    checked={checkoutMethods[2]}
                                    onChange={() => updateCheckoutMethods(2)}
                                  />
                                )}
                              </Row>
                              {checkoutMethodsError && (
                                <Row className="mx-0 text-danger">
                                  <Alert color="danger" className="mt-2 mb-0">
                                    {checkoutMethodsError}
                                  </Alert>
                                </Row>
                              )}
                            </>
                          )}
                        {paymentType === 'Money' && (
                          <Row className="w-100 mt-3 mx-0 mb-1 justify-content-end align-items-center flex-column flex-md-row">
                            <Col
                              xs={12}
                              className="px-0 d-flex justify-content-between"
                            >
                              <Label className="text-nowrap">
                                Troco para quanto?
                              </Label>
                              <CustomInput
                                type="switch"
                                id="changeInput"
                                name="changeInput"
                                label="Sem Troco"
                                checked={changeInput}
                                className="text-primary float-right"
                                onChange={handleNoChangeClick}
                              />
                            </Col>
                            <Col xs={12} className="px-0">
                              <IntlCurrencyInput
                                inputmode="decimal"
                                name="change"
                                disabled={changeInput}
                                currency="BRL"
                                className={`dc-discount-input input-color form-control ${
                                  !changeInput && changeErrorMessage
                                    ? 'border-danger'
                                    : ''
                                }`}
                                value={parseFloat(changeValue)}
                                onChange={(_e, floatValue) => {
                                  setChangeValue(floatValue);
                                }}
                                onFocus={() => {
                                  setChangeErrorMessage(null);
                                }}
                                config={{
                                  locale: 'pt-BR',
                                  formats: {
                                    number: {
                                      BRL: {
                                        style: 'currency',
                                        currency: 'BRL',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    },
                                  },
                                }}
                                onBlur={(_e, floatValue) => {
                                  if (
                                    floatValue >
                                    total + Number(freightWillBePayed)
                                  )
                                    return;
                                  setChangeErrorMessage(
                                    'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                  );
                                  formRef.current.setFieldError(
                                    'change',
                                    'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                  );
                                }}
                              />
                              {!changeInput && changeErrorMessage ? (
                                <span className="text-danger">
                                  {changeErrorMessage}
                                </span>
                              ) : null}
                            </Col>
                          </Row>
                        )}
                        {paymentType === 'Pago' &&
                          (cartState?.is_cross ||
                            cartState.delivery_method === 'CORREIOS') && (
                            <Col xs={12} sm={12} className="px-0">
                              <FormGroup>
                                <Alert color="info" className="mt-4 mb-0">
                                  Atenção: Para finalizar o pedido como Pago, é
                                  necessário cadastrar os produtos. O valor
                                  total será calculado com base nos itens
                                  adicionados.
                                </Alert>
                              </FormGroup>
                            </Col>
                          )}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )}
              {cartState?.is_for_delivery && (
                <Col
                  lg={6}
                  className={`px-0 py-2 ${
                    subscriberId === subscriberViddyComercial
                      ? 'pl-lg-0'
                      : 'pl-lg-2'
                  }`}
                >
                  <Card className="card new-layout h-100">
                    <CardBody className="card-body new-layout pb-0 pt-4 px-5">
                      <h2 className="font-size-20">Frete</h2>
                      {freeFreightAvailable && (
                        <Alert
                          color={freeFreightApplied ? 'success' : 'info'}
                          className="mt-3 mb-3"
                        >
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="pr-3">
                              <b className="d-block">
                                {freeFreightApplied
                                  ? 'Frete grátis aplicado nesta venda'
                                  : 'Frete grátis disponível para esta venda'}
                              </b>
                              <span className="font-size-12">
                                {freeFreightApplied
                                  ? 'O cliente não será cobrado pelo frete. Desative para informar um valor a ser cobrado.'
                                  : `O valor da compra atingiu ${formatPrice(
                                      freeFreightThreshold
                                    )} e liberou o frete grátis. Ative para não cobrar o frete do cliente.`}
                              </span>
                            </div>
                            <div className="d-flex align-items-center mt-2 mt-lg-2">
                              <CustomInput
                                type="switch"
                                id="useFreeFreightSwitch"
                                name="useFreeFreight"
                                label=""
                                checked={useFreeFreight}
                                className="text-primary"
                                onChange={() => setUseFreeFreight(v => !v)}
                              />
                              <span className="font-size-13 font-weight-bold text-primary ml-1">
                                {freeFreightApplied ? 'Ativado' : 'Desativado'}
                              </span>
                            </div>
                          </div>
                        </Alert>
                      )}
                      {cartState?.delivery_method === 'CORREIOS' ? (
                        <>
                          <Row className="w-100 mx-0 mt-3 mb-3">
                            {correiosOptions.map((option, index) => (
                              <Col
                                lg={6}
                                xs={12}
                                className={`px-0 mb-2 correios-freight-col ${
                                  index === 0
                                    ? 'correios-freight-col-left'
                                    : 'correios-freight-col-right'
                                }`}
                                key={option.code}
                              >
                                <button
                                  type="button"
                                  className={`correios-freight-card ${
                                    selectedCorreiosService?.code ===
                                    option.code
                                      ? 'active'
                                      : ''
                                  }`}
                                  onClick={() =>
                                    handleSelectCorreiosService(option)
                                  }
                                >
                                  <div className="correios-freight-radio-wrapper">
                                    <span className="correios-freight-radio" />
                                  </div>

                                  <div className="correios-freight-content">
                                    <h4 className="correios-freight-title">
                                      {option.name || option.code}
                                    </h4>

                                    <p className="correios-freight-deadline mb-2">
                                      <i className="las la-clock mr-1" />
                                      {option.deadline}
                                    </p>

                                    <div className="correios-freight-price-wrapper">
                                      <span className="correios-freight-price-label">
                                        Valor
                                      </span>
                                      <div className="correios-freight-price">
                                        {formatCurrency(
                                          option.price || option.value || 0
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </button>
                              </Col>
                            ))}
                          </Row>
                          <Row className="w-100 mx-0 mb-3">
                            <Col xs={12} className="px-0">
                              <div className="correios-freight-summary-card">
                                <div className="d-flex justify-content-between mb-2">
                                  <span className="text-muted">
                                    Custo da entrega (sistema):
                                  </span>
                                  <b>
                                    {freightValueAmount != null
                                      ? formatPrice(freightValueAmount)
                                      : 'Calculando...'}
                                  </b>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <span className="text-muted">
                                    Frete a ser cobrado do cliente:
                                  </span>
                                  <IntlCurrencyInput
                                    inputmode="decimal"
                                    currency="BRL"
                                    name="freightValue"
                                    id="freightValue"
                                    disabled={
                                      freeFreightApplied ||
                                      defaultFreight > 0 ||
                                      (useAutomaticFreight &&
                                        freightValueAmount > 0) ||
                                      subscriberId ===
                                        subscriberViddyComercial ||
                                      ((subscriberId === subscriberNomura ||
                                        subscriberId ===
                                          subscriberNomuraShoes) &&
                                        cartState?.delivery_method ===
                                          'CORREIOS')
                                    }
                                    onChange={(_, floatValue) => {
                                      setFreightWillBePayed(floatValue);
                                    }}
                                    className="dc-discount-input input-color form-control correios-freight-input"
                                    value={
                                      freeFreightApplied
                                        ? 0
                                        : parseFloat(freightWillBePayed)
                                    }
                                    config={{
                                      locale: 'pt-BR',
                                      formats: {
                                        number: {
                                          BRL: {
                                            style: 'currency',
                                            currency: 'BRL',
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          },
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                              {(subscriberId === subscriberNomura ||
                                subscriberId === subscriberNomuraShoes) && (
                                <Alert color="info" className="mt-4 mb-0">
                                  O valor de frete foi definido automaticamente
                                  como R$ 30,00 devido à seleção da opção de
                                  entrega (Correios).
                                </Alert>
                              )}
                            </Col>
                            {defaultFreight > 0 &&
                              !['CORREIOS_EXPRESS', 'CORREIOS'].includes(
                                cartState.delivery_method.trim()
                              ) && (
                                <Alert color="info" className="mt-4 mb-0">
                                  Valor de frete padrão configurado pela loja,
                                  para alterar, entre em contato com o
                                  administrador.
                                </Alert>
                              )}
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-3">
                            <Label className="mb-0">Custo da entrega</Label>
                            <b className="ml-2 font-size-14">
                              {freightValueAmount !== null ||
                              freightValueAmount > 0
                                ? formatPrice(freightValueAmount)
                                : 'Calculando...'}
                            </b>
                            {freightValueAmount === 0 &&
                              subscriberId === subscriberViddyComercial && (
                                <Alert color="danger" className="mt-4 mb-0">
                                  Valor de frete não identificado, pergunte ao
                                  suporte qual seria o custo desta entrega
                                  enquanto resolvemos este problema.
                                </Alert>
                              )}
                            {freightValueAmount === 0 &&
                              subscriberId !== subscriberViddyComercial && (
                                <Alert color="warning" className="mt-2 mb-0">
                                  Valor de frete não identificado, pergunte ao{' '}
                                  <a
                                    href={`https://wa.me/${formatWhatsappPhoneNumber(
                                      '5511935354434'
                                    )}?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%2C%20o%20custo%20da%20entrega%20est%C3%A1%20com%20valor%200%2C00%2C%20consegue%20me%20ajudar%3F`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    suporte
                                  </a>{' '}
                                  qual seria o custo desta entrega enquanto
                                  resolvemos este problema.
                                </Alert>
                              )}
                          </Row>

                          <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-1">
                            {paymentType === 'Pago' ? (
                              <Label>Frete pago pelo cliente</Label>
                            ) : (
                              <Label>Frete a ser cobrado do cliente</Label>
                            )}
                            <IntlCurrencyInput
                              inputmode="decimal"
                              disabled={
                                freeFreightApplied ||
                                defaultFreight > 0 ||
                                (useAutomaticFreight &&
                                  freightValueAmount > 0) ||
                                subscriberId === subscriberViddyComercial ||
                                ((subscriberId === subscriberNomura ||
                                  subscriberId === subscriberNomuraShoes) &&
                                  ['CORREIOS_EXPRESS', 'CORREIOS'].includes(
                                    cartState?.delivery_method
                                  ))
                              }
                              currency="BRL"
                              name="freightValue"
                              id="freightValue"
                              onChange={(_, floatValue) => {
                                setFreightWillBePayed(floatValue);
                              }}
                              placeholder="Valor Unitário"
                              className="dc-discount-input input-color form-control"
                              value={
                                freeFreightApplied
                                  ? 0
                                  : parseFloat(freightNormalInputValue)
                              }
                              config={{
                                locale: 'pt-BR',
                                formats: {
                                  number: {
                                    BRL: {
                                      style: 'currency',
                                      currency: 'BRL',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  },
                                },
                              }}
                              onBlur={(_e, floatValue) => {
                                if (floatValue + total <= changeValue) {
                                  setChangeErrorMessage(null);
                                  return;
                                }
                                setChangeErrorMessage(
                                  'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                );
                                formRef.current.setFieldError(
                                  'change',
                                  'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                                );
                              }}
                            />
                            {defaultFreight > 0 &&
                              !['CORREIOS_EXPRESS', 'CORREIOS'].includes(
                                cartState.delivery_method.trim()
                              ) && (
                                <Alert color="info" className="mt-4 mb-0">
                                  Valor de frete padrão configurado pela loja,
                                  para alterar, entre em contato com o
                                  administrador.
                                </Alert>
                              )}
                            {(subscriberId === subscriberNomura ||
                              subscriberId === subscriberNomuraShoes) &&
                              ['CORREIOS_EXPRESS', 'CORREIOS'].includes(
                                cartState.delivery_method
                              ) && (
                                <Alert color="info" className="mt-4 mb-0">
                                  O valor de frete foi definido automaticamente
                                  como R$ 30,00 devido à seleção da opção de
                                  entrega (Correios).
                                </Alert>
                              )}
                          </Row>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              )}

              {/*
              {cartState?.is_for_delivery && (
                <Col
                  lg={6}
                  className={`px-0 py-2 ${
                    subscriberId === subscriberViddyComercial
                      ? 'pl-lg-0'
                      : 'pl-lg-2'
                  }`}
                >
                  <Card className="card new-layout h-100">
                    <CardBody className="card-body new-layout pb-0 pt-4 px-5">
                      <h2 className="font-size-20">Frete</h2>

                      <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-3">
                        <Label className="mb-0">Custo da entrega</Label>
                        <b className="ml-2 font-size-14">
                          {freightValueAmount !== null || freightValueAmount > 0
                            ? formatPrice(freightValueAmount)
                            : 'Calculando...'}
                        </b>
                        {freightValueAmount === 0 &&
                          subscriberId === subscriberViddyComercial && (
                            <Alert color="danger" className="mt-4 mb-0">
                              Valor de frete não identificado, pergunte ao
                              suporte qual seria o custo desta entrega enquanto
                              resolvemos este problema.
                            </Alert>
                          )}
                        {freightValueAmount === 0 &&
                          subscriberId !== subscriberViddyComercial && (
                            <Alert color="warning" className="mt-2 mb-0">
                              Valor de frete não identificado, pergunte ao{' '}
                              <a
                                href={`https://wa.me/${formatWhatsappPhoneNumber(
                                  '5511935354434'
                                )}?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%2C%20o%20custo%20da%20entrega%20est%C3%A1%20com%20valor%200%2C00%2C%20consegue%20me%20ajudar%3F`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                suporte
                              </a>{' '}
                              qual seria o custo desta entrega enquanto
                              resolvemos este problema.
                            </Alert>
                          )}
                      </Row>
                      <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-1">
                        {paymentType === 'Pago' ? (
                          <Label>Frete pago pelo cliente</Label>
                        ) : (
                          <Label>Frete a ser cobrado do cliente</Label>
                        )}
                        <IntlCurrencyInput
                          inputmode="decimal"
                          disabled={
                            defaultFreight > 0 ||
                            (useAutomaticFreight && freightValueAmount > 0) ||
                            subscriberId === subscriberViddyComercial ||
                            ((subscriberId === subscriberNomura ||
                              subscriberId === subscriberNomuraShoes) &&
                              cartState?.delivery_method === 'CORREIOS')
                          }
                          currency="BRL"
                          name="freightValue"
                          id="freightValue"
                          onChange={(_, floatValue) => {
                            setFreightWillBePayed(floatValue);
                          }}
                          placeholder="Valor Unitário"
                          className="dc-discount-input input-color form-control"
                          value={
                            subscriberId === subscriberViddyComercial
                              ? parseFloat(freightWillBePayed) * 1.16
                              : parseFloat(freightWillBePayed)
                          }
                          config={{
                            locale: 'pt-BR',
                            formats: {
                              number: {
                                BRL: {
                                  style: 'currency',
                                  currency: 'BRL',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              },
                            },
                          }}
                          onBlur={(_e, floatValue) => {
                            if (floatValue + total <= changeValue) {
                              setChangeErrorMessage(null);
                              return;
                            }
                            setChangeErrorMessage(
                              'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                            );
                            formRef.current.setFieldError(
                              'change',
                              'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                            );
                          }}
                        />
                        {defaultFreight > 0 &&
                          !['CORREIOS'].includes(
                            cartState.delivery_method.trim()
                          ) && (
                            <Alert color="info" className="mt-4 mb-0">
                              Valor de frete padrão configurado pela loja, para
                              alterar, entre em contato com o administrador.
                            </Alert>
                          )}
                        {(subscriberId === subscriberNomura ||
                          subscriberId === subscriberNomuraShoes) &&
                          cartState.delivery_method === 'CORREIOS' && (
                            <Alert color="info" className="mt-4 mb-0">
                              O valor de frete foi definido automaticamente como
                              R$ 30,00 devido à seleção da opção de entrega
                              (Correios).
                            </Alert>
                          )}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )}
              */}

              {/*
              {cartState?.is_for_delivery && (
                <Col
                  lg={6}
                  className={`px-0 py-2 ${
                    subscriberId === subscriberViddyComercial
                      ? 'pl-lg-0'
                      : 'pl-lg-2'
                  }`}
                >
                  <Card className="card new-layout h-100">
                    <CardBody className="card-body new-layout pb-0 pt-4 px-5">
                      <h2 className="font-size-20">Frete</h2>

                      <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-3">
                        <Label className="mb-0">Custo da entrega</Label>
                        <b className="ml-2 font-size-14">
                          {freightValueAmount !== null || freightValueAmount > 0
                            ? formatPrice(freightValueAmount)
                            : 'Calculando...'}
                        </b>
                        {freightValueAmount === 0 &&
                          subscriberId === subscriberViddyComercial && (
                            <Alert color="danger" className="mt-4 mb-0">
                              Valor de frete não identificado, pergunte ao
                              suporte qual seria o custo desta entrega enquanto
                              resolvemos este problema.
                            </Alert>
                          )}
                        {freightValueAmount === 0 &&
                          subscriberId !== subscriberViddyComercial && (
                            <Alert color="warning" className="mt-2 mb-0">
                              Valor de frete não identificado, pergunte ao{' '}
                              <a
                                href={`https://wa.me/${formatWhatsappPhoneNumber(
                                  '5511935354434'
                                )}?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%2C%20o%20custo%20da%20entrega%20est%C3%A1%20com%20valor%200%2C00%2C%20consegue%20me%20ajudar%3F`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                suporte
                              </a>{' '}
                              qual seria o custo desta entrega enquanto
                              resolvemos este problema.
                            </Alert>
                          )}
                      </Row>
                      <Row className="w-100 mx-0 d-flex flex-row align-items-center mb-1">
                        {paymentType === 'Pago' ? (
                          <Label>Frete pago pelo cliente</Label>
                        ) : (
                          <Label>Frete a ser cobrado do cliente</Label>
                        )}
                        <IntlCurrencyInput
                          inputmode="decimal"
                          disabled={
                            defaultFreight > 0 ||
                            (useAutomaticFreight && freightValueAmount > 0) ||
                            subscriberId === subscriberViddyComercial ||
                            ((subscriberId === subscriberNomura ||
                              subscriberId === subscriberNomuraShoes) &&
                              cartState?.delivery_method === 'CORREIOS')
                          }
                          currency="BRL"
                          name="freightValue"
                          id="freightValue"
                          onChange={(_, floatValue) => {
                            setFreightWillBePayed(floatValue);
                          }}
                          placeholder="Valor Unitário"
                          className="dc-discount-input input-color form-control"
                          value={
                            subscriberId === subscriberViddyComercial
                              ? parseFloat(freightWillBePayed) * 1.16
                              : parseFloat(freightWillBePayed)
                          }
                          config={{
                            locale: 'pt-BR',
                            formats: {
                              number: {
                                BRL: {
                                  style: 'currency',
                                  currency: 'BRL',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              },
                            },
                          }}
                          onBlur={(_e, floatValue) => {
                            if (floatValue + total <= changeValue) {
                              setChangeErrorMessage(null);
                              return;
                            }
                            setChangeErrorMessage(
                              'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                            );
                            formRef.current.setFieldError(
                              'change',
                              'Para que haja troco, o valor inserido deve ser maior que o valor da compra.'
                            );
                          }}
                        />
                        {defaultFreight > 0 &&
                          !['CORREIOS'].includes(
                            cartState.delivery_method.trim()
                          ) && (
                            <Alert color="info" className="mt-4 mb-0">
                              Valor de frete padrão configurado pela loja, para
                              alterar, entre em contato com o administrador.
                            </Alert>
                          )}
                        {(subscriberId === subscriberNomura ||
                          subscriberId === subscriberNomuraShoes) &&
                          cartState.delivery_method === 'CORREIOS' && (
                            <Alert color="info" className="mt-4 mb-0">
                              O valor de frete foi definido automaticamente como
                              R$ 30,00 devido à seleção da opção de entrega
                              (Correios).
                            </Alert>
                          )}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )}
              */}

              {cartState?.store?.has_crmbonus_key &&
                paymentType === 'Link' &&
                subscriberId !== subscriberViddyComercial && (
                  <Col lg={6} className="px-0 py-2 pr-lg-2">
                    <Card className="card new-layout h-100">
                      <CardBody className="card-body new-layout pb-0 pt-4 px-5">
                        <GiftbackCard
                          saldoDisponivel={saldoDisponivel}
                          saldoTotal={saldoTotal}
                          dataExpiracao={dataExpiracao}
                          valorMinimoResgate={valorMinimoResgate}
                          valorCompra={Number(total)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          isLoadingGiftback={isLoadingGiftback}
                          isGiftbackActive={isGiftbackActive}
                          onSwitchChange={handleGiftbackSwitchChange}
                          setTotal={setTotal}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
              <Col lg={12} className="px-0 py-2">
                <Card className="card new-layout">
                  <CardBody
                    className="card-body new-layout py-4 px-4"
                    style={{ backgroundColor: '#E8E8E8' }}
                  >
                    <Col>
                      <Row className="w-100 mx-0 d-flex flex-row justify-content-center align-items-center flex-nowrap">
                        <Label className="ml-3 mb-0">
                          Valor total do pedido
                        </Label>
                        <b className="ml-2 font-size-14">
                          {freightValueAmount !== null ||
                          (returnFreightValueAmount !== null && total !== null)
                            ? formatPrice(
                                chargedFreight +
                                  Number(returnFreightValueAmount || 0) +
                                  Number(total || 0) -
                                  (isGiftbackActive ? saldoDisponivel : 0)
                              )
                            : 'Calculando...'}
                        </b>
                      </Row>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0" align="end">
                <Button
                  color="primary"
                  size="lg"
                  type="button"
                  className="float-right w-lg-25 new-layout-btn main"
                  disabled={isBtnDisabled}
                  onClick={handleFinishOrder}
                >
                  Avançar
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Form>
      <PixQrCodeModal
        show={showPixQrCodeModal}
        loading={loadingQrCode}
        qrCode={pixQrCode}
      />
    </>
  );
};

export default Payment;
